import { render, staticRenderFns } from "./BaseSubTable.vue?vue&type=template&id=7191f71f&"
import script from "./BaseSubTable.vue?vue&type=script&lang=js&"
export * from "./BaseSubTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports